import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


interface DeleteTreatmentSegmentPayload {
  projectId: string;
  featureId: string;
  treatmentId: string;
  segmentId:string;

}

const deleteMappedSegment = async (payload: DeleteTreatmentSegmentPayload) => {
  try {
    const url = paths.deleteMappedSegment();
    const response = await axiosInstance.post(url, {input: payload});
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
  
};

export const useDeleteMappedSegment = () => {
  return useMutation(deleteMappedSegment);
}; 